// Imperative navigate utility for use outside of React components (thunks, Apollo error handlers, etc.)
// Set by NavigateSetter inside the Router tree in App.js.
import type { NavigateFunction, To, NavigateOptions } from "react-router-dom";

let _navigate: NavigateFunction | undefined;

export function setNavigate(fn: NavigateFunction) {
  _navigate = fn;
}

export function navigate(to: To, options?: NavigateOptions) {
  void _navigate?.(to, options);
}

// Open-redirect guard: parse the input through the URL API against the current
// origin, then rebuild the path from the parsed components. Anything resolving
// to a different origin (protocol-relative "//evil.com", absolute "https://...",
// "javascript:...", etc.) falls back to "/". Returning freshly-constructed
// origin/pathname/search/hash strings also breaks taint flow for static
// analyzers like Snyk Code.
export function safeInternalPath(input: unknown): string {
  if (typeof input !== "string") return "/";
  try {
    const origin = window.location.origin;
    const url = new URL(input, origin);
    if (url.origin !== origin) return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}
